export default defineI18nConfig(() => ({
    fallbackLocale: 'fr-FR',
}));
